import React from 'react';
import { useLocation } from 'react-router-dom';

import { NavLink } from 'react-router-dom';

const Nav = () => {
    const location = useLocation();
    const activelink = (status) => {
        if (status) {
            return 'orb-current';
        }
        return '';
    };

    const activemenu = (status) => {
        if (status) {
            return 'orb-current-menu';
        }
        return '';
    };

    return (
        <nav>
            <ul className="orb-menu">
                <li className="orb-has-children orb-has-link">
                    <NavLink
                        to="/"
                        className={({ isActive }) => activelink(isActive)}
                    >
                        Inicio
                    </NavLink>
                </li>
                <li className="orb-has-children orb-has-menu">
                    <a
                        href="#."
                        onClick={(e) => e.preventDefault()}
                        className={
                            location.pathname === '/biografia' ||
                            location.pathname === '/museo' ||
                            location.pathname === '/gastronomia' ||
                            location.pathname === '/programa' ||
                            location.pathname === '/procesiones' ||
                            location.pathname === '/alabanzas' ||
                            location.pathname === '/oraciones'
                                ? 'orb-current'
                                : ''
                        }
                    >
                        San Roque
                    </a>
                    <ul>
                        <li>
                            <NavLink
                                to="/biografia"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Biografía
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/museo"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Museo
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/gastronomia"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Gastronomía
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/programa"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Programa 2022
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/procesiones"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Procesiones
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/alabanzas"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Alabanzas
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/oraciones"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Oraciones
                            </NavLink>
                        </li>
                    </ul>
                </li>
                <li className="orb-has-children orb-has-menu">
                    <a
                        href="#."
                        onClick={(e) => e.preventDefault()}
                        className={
                            location.pathname === '/historia' ||
                            location.pathname === '/vestimenta' ||
                            location.pathname === '/musica'
                                ? 'orb-current'
                                : ''
                        }
                    >
                        Los Chunchos
                    </a>
                    <ul>
                        <li>
                            <NavLink
                                to="/historia"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Historia
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/vestimenta"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Vestimenta
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/musica"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Música y Danza
                            </NavLink>
                        </li>
                    </ul>
                </li>
                <li className="orb-has-children orb-has-menu">
                    <a
                        href="#."
                        onClick={(e) => e.preventDefault()}
                        className={
                            location.pathname === '/pemcat' ||
                            location.pathname === '/colaboraciones' ||
                            location.pathname === '/contactos' ||
                            location.pathname === '/comite'
                                ? 'orb-current'
                                : ''
                        }
                    >
                        Sobre Nosotros
                    </a>
                    <ul>
                        <li>
                            <NavLink
                                to="/pemcat"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                PEMCAT
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/comite"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Comité
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/colaboraciones"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Colaboraciones
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contactos"
                                className={({ isActive }) =>
                                    activemenu(isActive)
                                }
                            >
                                Contactos
                            </NavLink>
                        </li>
                    </ul>
                </li>
                <li className="orb-has-children orb-has-link">
                    <NavLink
                        to="/unesco"
                        className={({ isActive }) => activelink(isActive)}
                    >
                        Unesco
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
};

export default Nav;
